import { PackageApprovalStatusState, PackageApprovalStatus } from '../types'
import Vue from 'vue'
import { GetterTree, MutationTree, ActionTree } from 'vuex'
import ApiResponse from 'models/apiResponse'


const state: PackageApprovalStatusState = {
    list: [],
    timestampMS: null
}

const getters: GetterTree<PackageApprovalStatusState, any> = {
    getPackageApprovalStatusList: state => () => {
        return state.list;
    }
}

const mutations: MutationTree<PackageApprovalStatusState> = {
    setPackageApprovalStatusList(state, data) {
        //reset list first.
        state.list = [];
        data.forEach((packageApprovalStatus: PackageApprovalStatus, index) => {
            Vue.set(state.list, index, packageApprovalStatus);
        });
    },
    setPackageApprovalStatusTimestamp(state) {
        // 24 hours
        const expiration = 24 * 60 * 60 * 1000;
        state.timestampMS = new Date().getTime() + expiration;
    }
}

const actions: ActionTree<PackageApprovalStatusState, any> = {
    async fetchPackageApprovalStatus({ commit, state, dispatch }) {
            if (state.list.length == 0 || (state.timestampMS && new Date().getTime() > state.timestampMS)) {
                await dispatch('refreshPackageApprovalStatus');
            }
    },
    async refreshPackageApprovalStatus({ commit, state }) {
        const url = Vue.IdentityConfig.legacyApiUri + "/remote/packageapprovalstatus";
        const options: RequestInit = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            cache: "no-cache"
        };
        await fetch(url, options)
            .then(response => response.json() as Promise<ApiResponse<PackageApprovalStatus>>)
            .then(data => {
                if (data.result) {
                    commit('setPackageApprovalStatusList', data.result);
                    commit('setPackageApprovalStatusTimestamp');
                }
                if (data.errors) {
                    data.errors.forEach(e => Vue.Logger.LogError(e.message));
                }
            });
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}